import { HeaderStyledProps, HeaderProps } from '@Components/Text/Header/types';
import styled from 'styled-components';

function getWeightFromProps(props: HeaderStyledProps) {
	let fontWeightAttr = 'font-weight: ';
	switch (props.weight) {
		case 'bold':
			return (fontWeightAttr += 700);
		case 'semibold':
			return (fontWeightAttr += 600);
		case 'regular':
			return (fontWeightAttr += 500);
		case 'light':
			return (fontWeightAttr += 400);
		default:
			return (fontWeightAttr += 600);
	}
}

const StyledH1 = styled.h1<HeaderStyledProps>`
	font-size: 1.68rem;
	margin: 0;
	${(props) => getWeightFromProps(props)}
`;
const StyledH2 = styled.h2<HeaderStyledProps>`
	font-size: 1.476rem;
	margin: 0;
	${(props) => getWeightFromProps(props)}
`;
const StyledH3 = styled.h3<HeaderStyledProps>`
	font-size: 1.296rem;
	margin: 0;
	${(props) => getWeightFromProps(props)}
`;
const StyledH4 = styled.h4<HeaderStyledProps>`
	font-size: 1.215rem;
	margin: 0;
	${(props) => getWeightFromProps(props)}
`;
const StyledH5 = styled.h5<HeaderStyledProps>`
	font-size: 1.138rem;
	margin: 0;
	${(props) => getWeightFromProps(props)}
`;
const StyledH6 = styled.h6<HeaderStyledProps>`
	font-size: 1.067rem;
	margin: 0;
	${(props) => getWeightFromProps(props)}
`;
const StyledH7 = styled.h6<HeaderStyledProps>`
	font-size: 1rem;
	margin: 0;
	${(props) => getWeightFromProps(props)}
`;

export function getStyledHeader(level: HeaderProps['variant']) {
	switch (level) {
		case 'h1':
			return StyledH1;
		case 'h2':
			return StyledH2;
		case 'h3':
			return StyledH3;
		case 'h4':
			return StyledH4;
		case 'h5':
			return StyledH5;
		case 'h6':
			return StyledH6;
		case 'h7':
			return StyledH7;
		default:
			return StyledH1;
	}
}
